import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["role", "university", "groupsSelect", "profileTypesSelect"]
  static values = {
    rolesWithUniversity: Array,
    groupAdminRoleId: Number,
    idpContentManagerRoleId: Number,
    universityStudentRoleId: Number
  }

  connect() {
    this.checkRole()
    this.showGroupsSelect()
    this.toggleProfileTypeSelectVisibility()
  }

  checkRole() {
    if (!this.hasUniversityTarget) return

    if (this.isRoleWithUniversitySelected()) {
      this.universityTarget.classList.remove("hidden!")
    }
    else {
      this.universityTarget.classList.add("hidden!")
      const universityInputId = this.universityTarget.querySelector('select').id
      const event = new CustomEvent(
        "tom-select:clear",
        { bubbles: true, detail: { target: universityInputId } }
      )
      this.universityTarget.dispatchEvent(event)
    }
  }

  isRoleWithUniversitySelected() {
    return this.rolesWithUniversityValue.includes(parseInt(this.roleTarget.value))
  }

  isUniversityStudentRoleSelected() {
    return parseInt(this.roleTarget.value) === this.universityStudentRoleIdValue
  }

  showGroupsSelect() {
    if (!this.hasGroupsSelectTarget) return

    if (this.isGroupPanelRoleSelected()) {
      this.groupsSelectTarget.classList.remove("hidden")
    } else {
      this.groupsSelectTarget.classList.add("hidden")
      this.clearGroupSelect()
    }
  }

  isGroupPanelRoleSelected() {
    const selectedRoleId = parseInt(this.roleTarget.value)

    return selectedRoleId === this.groupAdminRoleIdValue || selectedRoleId === this.idpContentManagerRoleIdValue
  }

  toggleProfileTypeSelectVisibility() {
    if (!this.hasProfileTypesSelectTarget) return

    if (this.isUniversityStudentRoleSelected()) {
      this.profileTypesSelectTarget.classList.remove("hidden")
    } else {
      this.profileTypesSelectTarget.classList.add("hidden")
      this.clearProfileTypeSelect()
    }
  }

  clearGroupSelect() {
    const groupsSelectInputId = this.groupsSelectTarget.querySelector('select').id
    const event = new CustomEvent(
      "tom-select:clear",
      { bubbles: true, detail: { target: groupsSelectInputId } }
    )
    this.groupsSelectTarget.dispatchEvent(event)
  }

  clearProfileTypeSelect() {
    const profileTypesSelectInputId = this.profileTypesSelectTarget.querySelector('select').id
    const event = new CustomEvent(
      "tom-select:clear",
      { bubbles: true, detail: { target: profileTypesSelectInputId } }
    )
    this.profileTypesSelectTarget.dispatchEvent(event)
  }
}
